export default __webpack_public_path__ + "static/media/wqphn-logo.659cd3bc.svg";